import { TextContainer, Text } from "@wayflyer/flyui";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import { MESSAGES } from "../message-definitions";

export const GeographyLetDown = ({ eligibilityLink }: { eligibilityLink: ReactNode }) => {
  const intl = useIntl();

  const paragraphs: ReactNode[][] = [];
  intl.formatMessage(MESSAGES.letDownReasonGeography, {
    p: (chunks: ReactNode[]) => {
      paragraphs.push(chunks);
      return null;
    },
  });

  return (
    <TextContainer>
      {paragraphs.map((chunks, index) => (
        <Text key={index}>
          {chunks}
          {index === paragraphs.length - 1 ? <> {eligibilityLink}</> : null}
        </Text>
      ))}
    </TextContainer>
  );
};
